import React from 'react'
import PropTypes from 'prop-types'
import BadgeIndicator from './badge-indicator'
import ProfileCompleteBadgeIcon from './profile-complete-badge-icon'

const PROFILE_COMPLETION_BADGE_NAMES = [
  'org_profile',
  'ta_profile',
  'sc_profile',
]

function ActiveBadges({ badges, size }) {
  const activeBadges = (badges || []).filter((badge) => badge.active)

  return activeBadges.map((badge) =>
    PROFILE_COMPLETION_BADGE_NAMES.includes(badge.name) ? (
      <div
        key={`badge-${badge.id || badge.name}`}
        className="profile-complete-badge"
      >
        <div className="profile-complete-badge__icon" aria-hidden>
          <ProfileCompleteBadgeIcon />
        </div>
        <p>
          <strong>{badge.questionText || badge.name}</strong>
        </p>
      </div>
    ) : (
      <BadgeIndicator
        key={`badge-${badge.id || badge.name}`}
        iconUrl={badge.iconUrl}
        label={badge.questionText || badge.name}
        size={size}
      />
    )
  )
}

ActiveBadges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.object),
  size: PropTypes.number,
}

ActiveBadges.defaultProps = {
  badges: [],
  size: 40,
}

export default React.memo(ActiveBadges)
